/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Upload_Person_Document_BodyInputs */



/**
* | output |
* | --- |
* | "Do you have notes about this person? Upload them, and Wundo will take them into account." |
*
* @param {Nudge_Upload_Person_Document_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_upload_person_document_body = /** @type {((inputs?: Nudge_Upload_Person_Document_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Upload_Person_Document_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Heb je notities over deze gesprekspartner? Upload ze, dan houdt Wundo er rekening mee.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez des notes sur cette personne ? Téléversez-les, et Wundo en tiendra compte.")
	return /** @type {LocalizedString} */ ("Do you have notes about this person? Upload them, and Wundo will take them into account.")
});